import "shared/styles/Sidebar.css";
import React, {memo} from "react";
import {Category} from "features/validationRules/types";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; 
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import {useNavigate} from "react-router-dom";

const CategoryComponent = ({category: {cat_id, cat_num}, isActive, rmCategory}: { category: Category, isActive: boolean, setActiveCategory: React.Dispatch<React.SetStateAction<Category | undefined>>, rmCategory: (cat_id: number) => void }) => {
    const navigate = useNavigate();

    const onDelete = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        event.stopPropagation();
        rmCategory(cat_id)
    }
    
    return (
        <div className={`category-container category-container-${isActive ? "" : "in"}active`}
             onClick={() => navigate(`/categories/${cat_num}`)}>
            <p className="cat-name">{cat_num}</p>
            <button className="button red-button" onClick={onDelete}><FontAwesomeIcon icon={faTrash}/></button>
        </div>
    );
}

export default memo(CategoryComponent);